import { Grid } from '@mui/material';
import SubmissionDeleteButton from './SubmissionDeleteButton';
import SubmissionNewBuildButton from './SubmissionNewBuildButton';
import ReleaseSubmission from './ReleaseSubmissionButton';
import { StyledButton } from '../../../../../../../common/Styleguide/Common/Button';
import SubmissionCommercialInfoButton from './SubmissionCommercialInfoButton';
import React from 'react';
import { SubmissionContext } from '../../Context/SubmissionProvider';

interface SubmissionOverviewButtonsProps {
  goToInfoUpdate(): void;
  createNewGameBuild(): void;
}

const SubmissionOverviewButtons: React.FC<SubmissionOverviewButtonsProps> = ({
  goToInfoUpdate,
  createNewGameBuild,
}: SubmissionOverviewButtonsProps) => {
  const { submission } = React.useContext(SubmissionContext);
  const shouldDisplayReleaseButton = submission && submission.status === 'SYNC_REQUIRED' && submission.developer?.hasReleaseRights;

  return (
    <Grid container gap={2}>
      <SubmissionNewBuildButton createNewGameBuild={createNewGameBuild} />

      <StyledButton
        sx={{
          borderRadius: '8px',
          width: '100%',
        }}
        variant="contained"
        onClick={goToInfoUpdate}
      >
        Update game info
      </StyledButton>

      <SubmissionCommercialInfoButton />

      {shouldDisplayReleaseButton && <ReleaseSubmission submission={submission} />}

      <SubmissionDeleteButton />
    </Grid>
  );
};

export default SubmissionOverviewButtons;
